import { useAutocompleteSource } from '@eas/common-web';
import { CertificationAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useCertifications() {
  return useAutocompleteSource<CertificationAutocomplete>({
    url: `${EvidenceApiUrl.CERTIFICATION}/autocomplete`,
  });
}
